export default __webpack_public_path__ + "static/media/Sky_9781843620204.26ec086c.jpg";